import { GET, POST, PUT, DELETE } from "../../api";

export const Country = async (id) => {
  return await GET(`/common/masters/all-country`);
};

export const State = async (id) => {
  return await GET(`/common/masters/all-state/${id}`);
};

export const City = async (id) => {
  return await GET(`/common/masters/all-city/${id}`);
};

export const Pincode = async (id) => {
  return await GET(`/common/masters/all-pincode/${id}`);
};

export const Modules = async () => {
  return await GET(`/common/masters/all-modules`);
};

export const ThingToDo = async () => {
  return await GET(`/common/masters/all-things-to-do`);
};

export const ExploreType = async () => {
  return await GET(`/common/masters/all-explore-type`);
};